import { Divider } from '@mui/material';
import React, { useState } from 'react';
import { PaywallCard } from './PaywallCard';
import {
  ActiveProjects,
  projectLimitInfo,
  ProPlanPrice,
} from '@shared/models/paywall.model';

const projectLimitInfoLookup = projectLimitInfo.reduce(
  (acc, { activeProjects, price }) => {
    acc[activeProjects] = price;
    return acc;
  },
  {} as Record<ActiveProjects, ProPlanPrice>,
);

const features = [
  'Team collaboration',
  'Decision report + Excel export',
  'Create and share your own templates',
  'AI EPD-reading',
  'AI climate expert',
  'Standard support',
];

export const ProPlan = () => {
  const [activeProjects, setActiveProjects] = useState<ActiveProjects>('3');

  return (
    <PaywallCard>
      <PaywallCard.Header
        title="Pro"
        chipLabel="popular"
        subheader="For teams running multiple projects per year."
      />
      <PaywallCard.Price>
        <PaywallCard.PricePerMonth
          price={projectLimitInfoLookup[activeProjects]}
          subtext="shared across unlimited users"
        />
      </PaywallCard.Price>
      <Divider />
      <PaywallCard.Submit
        plan="pro"
        text="Upgrade"
        billedAnnually
        activeProjects={activeProjects}
      />
      <PaywallCard.ActiveProjectsSelect
        selected={activeProjects}
        onSelect={setActiveProjects}
      />
      <PaywallCard.Features
        header="All features in Free, plus"
        features={features}
      />
    </PaywallCard>
  );
};
